import { Link } from "react-router-dom";
import styled from "styled-components";
import {
    List,
    Close,
    Person,
    ShoppingCartOutlined,
    Search,
    Archive,
    ExitToApp,
} from "@material-ui/icons";
import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../redux/userRedux";
import { mobile, tablet } from "../responsive";
import { HiLockOpen } from "react-icons/hi";
import { clearCart } from "../redux/cartRedux";
import { FormattedMessage } from "react-intl";

const Container = styled.div``;

const MenuContainer = styled.div`
    display: none;
    ${mobile({
        display: "flex",
        alignItems: "center",
        padding: "10px 15px",
        background: "white",
        color: "black",
    })}
`;

const Dropddown = styled.div`
    padding-top: 15px;
    height: 100vh;
    color: black;
    display: flex;
    flex-direction: column;
`;

const NavbarAuth = styled.div`
    &.hidden {
        display: none;
    }
`;

const LogoContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`

const Logo = styled.img`
    width: 100px;
    ${tablet({ width: "120px" })}
`;

const Left = styled.div`
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items:center;
`;

const Center = styled.div`
    font-size: 1.5rem;
    cursor: pointer;
    font-family: Jost-Bold;
    flex: 1;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const Right = styled.div`
    flex: 1;
    display: flex;
    justify-content: flex-end;
    align-items: center;
`;

const MobileNavbar = ({onLocaleChange, locale}) => {
    const [showMenu, setShowMenu] = useState(false);
    const [showSeries, setShowSeries] = useState(false);
    const currentUser = useSelector((state) => state.user);
    const dispatch = useDispatch();

    const handleClick = () => {
        dispatch(logout());
        dispatch(clearCart())
    };
    return (
        <>
            <Container>
                {" "}
                <MenuContainer>
                    {" "}
                    <Left>
                        {" "}
                        {showMenu ? (
                            <Close
                                onClick={() => {
                                    setShowSeries(false);
                                    setShowMenu(false);
                                }}
                                style={{ fontSize: "18px" }}
                            ></Close>
                        ) : (
                            <>
                                <List
                                    onClick={() => {
                                        setShowSeries(false);
                                        setShowMenu(true);
                                    }}
                                    style={{ fontSize: "18px" }}
                                ></List>
                            </>
                        )}
                        <Link
                            style={{ textDecoration: "none", color: "black", }}
                            to={{
                                pathname: "/search",
                                state: {
                                    model: "",
                                },
                            }}
                        >
                            <Search
                                style={{ fontSize: "18px", marginLeft: "8px" }}
                            ></Search>
                        </Link>
                        <div className="flex justify-center ml-3">
                            <select className="w-10 text-center text-xs" value={locale} onChange={(e) => onLocaleChange(e.target.value)}>
                                <option value="en">EN</option>
                                <option value="es">中</option>
                            </select>
                        </div>
                    </Left>
                    <Center>
                        <Link
                            style={{
                                textDecoration: "none",
                                color: "black",
                            }}
                            to="/"
                        >
                            <LogoContainer>
                            <Logo
                                src={
                                    "https://ik.imagekit.io/dnddecpho/airvitamin/air-logo_xVbwmEdOS.jpg?updatedAt=1734429910967"
                                }
                            ></Logo>
                            </LogoContainer>
                        </Link>
                    </Center>
                    <Right>
                        <Link
                            to="/register"
                            style={
                                currentUser.currentUser === null
                                    ? {
                                          textDecoration: "none",
                                          color: "black",
                                          marginRight: "8px",
                                      }
                                    : { display: "none" }
                            }
                        >
                            <NavbarAuth
                                className={
                                    currentUser.currentUser !== null
                                        ? "hidden"
                                        : null
                                }
                                style={{
                                    fontSize: "10px",
                                }}
                            >
                                <FormattedMessage id="navbar_subtitle_register" defaultMessage="" />
                            </NavbarAuth>
                        </Link>
                        
                        <Link
                            to="/login"
                            style={
                                currentUser.currentUser === null
                                    ? {
                                          textDecoration: "none",
                                          color: "black",
                                          marginRight: "8px",
                                      }
                                    : { display: "none" }
                            }
                        >
                            <HiLockOpen
                                className={
                                    currentUser.currentUser !== null
                                        ? "hidden"
                                        : null
                                }
                                style={{
                                    fontSize: "18px",
                                }}
                            ></HiLockOpen>
                        </Link>

                        <Link
                            to="/order"
                            style={
                                currentUser.currentUser !== null
                                    ? {
                                          textDecoration: "none",
                                          color: "black",
                                          marginRight: "8px",
                                      }
                                    : { display: "none" }
                            }
                        >
                            <NavbarAuth
                                className={
                                    currentUser.currentUser === null
                                        ? "hidden"
                                        : null
                                }
                            >
                                <Archive style={{ fontSize: "18px" }}></Archive>
                            </NavbarAuth>
                        </Link>

                        <Link
                            to="/profile"
                            style={
                                currentUser.currentUser !== null
                                    ? {
                                          textDecoration: "none",
                                          color: "black",
                                          marginRight: "8px",
                                      }
                                    : { display: "none" }
                            }
                        >
                            <Person
                                className={
                                    currentUser.currentUser === null
                                        ? "hidden"
                                        : null
                                }
                                style={{ fontSize: "18px" }}
                            ></Person>
                        </Link>

                        <Link
                            style={{
                                textDecoration: "none",
                                color: "black",
                                marginRight: "8px",
                            }}
                            to="/cart"
                        >
                            <NavbarAuth
                            >
                                <ShoppingCartOutlined style={{ fontSize: "18px" }}></ShoppingCartOutlined>
                            </NavbarAuth>
                        </Link>

                        <div
                            style={
                                currentUser.currentUser !== null
                                    ? {
                                          textDecoration: "none",
                                          color: "black",
                                          cursor: "pointer",
                                      }
                                    : { display: "none" }
                            }
                            className={
                                currentUser.currentUser == null
                                    ? "hidden"
                                    : null
                            }
                            onClick={handleClick}
                        >
                            <NavbarAuth
                                className={
                                    currentUser.currentUser == null
                                        ? "hidden"
                                        : null
                                }
                            >
                                <ExitToApp style={{ fontSize: "18px" }}></ExitToApp>
                            </NavbarAuth>
                        </div>
                    </Right>
                </MenuContainer>
                {showMenu && (
                    <Container>
                        <Dropddown>
                            {" "}
                            <Link
                                style={{
                                    textDecoration: "none",
                                    padding: "20px",
                                }}
                                to="/"
                                onClick={() => {
                                    setShowMenu(false);
                                }}
                            >
                                <FormattedMessage id="navbar_subtitle_1" defaultMessage="" />
                            </Link>
                            <Link
                                style={{
                                    textDecoration: "none",
                                    padding: "20px",
                                }}
                                to="/about"
                                onClick={() => {
                                    setShowMenu(false);
                                }}
                            >
                               <FormattedMessage id="navbar_subtitle_2" defaultMessage="" />
                            </Link>
                            <Link
                                style={{
                                    textDecoration: "none",
                                    padding: "20px",
                                }}
                                to="/background"
                                onClick={() => {
                                    setShowMenu(false);
                                }}
                            >
                                <FormattedMessage id="navbar_subtitle_3" defaultMessage="" />
                            </Link>
                            <Link
                                style={{
                                    textDecoration: "none",
                                    padding: "20px",
                                }}
                                to="/demo"
                                onClick={() => {
                                    setShowMenu(false);
                                }}
                            >
                                <FormattedMessage id="navbar_subtitle_4" defaultMessage="" />
                            </Link>
                            <Link
                                style={{
                                    textDecoration: "none",
                                    padding: "20px",
                                }}
                                to="/gallery"
                                onClick={() => {
                                    setShowMenu(false);
                                }}
                            >
                                <FormattedMessage id="navbar_subtitle_5" defaultMessage="" />
                            </Link>
                            <Link
                                style={{
                                    textDecoration: "none",
                                    padding: "20px",
                                }}
                                to="/product/G10"
                                onClick={() => {
                                    setShowMenu(false);
                                }}
                            >
                                <FormattedMessage id="navbar_subtitle_6" defaultMessage="" />
                            </Link>
                            <Link
                                style={{
                                    textDecoration: "none",
                                    padding: "20px",
                                }}
                                to="/search"
                                onClick={() => {
                                    setShowMenu(false);
                                }}
                            >
                                <FormattedMessage id="navbar_subtitle_7" defaultMessage="" />
                            </Link>
                            <Link
                                style={{
                                    textDecoration: "none",
                                    padding: "20px",
                                }}
                                to="/contact"
                                onClick={() => {
                                    setShowMenu(false);
                                }}
                            >
                                <FormattedMessage id="navbar_subtitle_8" defaultMessage="" />
                            </Link>
                            <NavbarAuth
                                style={{
                                    textDecoration: "none",
                                    padding: "20px",
                                }}
                                className={
                                    currentUser.currentUser == null
                                        ? "hidden"
                                        : null
                                }
                                onClick={() => handleClick()}
                            >
                                <FormattedMessage id="navbar_subtitle_9" defaultMessage="" />
                            </NavbarAuth>
                        </Dropddown>
                    </Container>
                )}
                {showSeries && (
                    <Container>
                        <Dropddown>
                            <Link
                                style={{
                                    textDecoration: "none",
                                    padding: "20px",
                                }}
                                onClick={() => {
                                    setShowSeries(false);
                                    setShowMenu(false);
                                }}
                                to="/products/self-winding"
                            >
                                Self-Winding Tourbillon
                            </Link>
                            <Link
                                style={{
                                    textDecoration: "none",
                                    padding: "20px",
                                }}
                                onClick={() => {
                                    setShowSeries(false);
                                    setShowMenu(false);
                                }}
                                to="/products/manual"
                            >
                                Manual Tourbillon
                            </Link>
                            <Link
                                style={{
                                    textDecoration: "none",
                                    padding: "20px",
                                }}
                                onClick={() => {
                                    setShowSeries(false);
                                    setShowMenu(false);
                                }}
                                to="/products/crystal"
                            >
                                Crystal Series
                            </Link>
                            <Link
                                style={{
                                    textDecoration: "none",
                                    padding: "20px",
                                }}
                                onClick={() => {
                                    setShowSeries(false);
                                    setShowMenu(false);
                                }}
                                to="/products/carousel"
                            >
                                Carousel Series
                            </Link>
                            <Link
                                style={{
                                    textDecoration: "none",
                                    padding: "20px",
                                }}
                                onClick={() => {
                                    setShowSeries(false);
                                    setShowMenu(false);
                                }}
                                to="/products/mechanical"
                            >
                                Automatic Mechanical
                            </Link>
                            <Link
                                style={{
                                    textDecoration: "none",
                                    padding: "20px",
                                }}
                                onClick={() => {
                                    setShowSeries(false);
                                    setShowMenu(false);
                                }}
                                to="/products/women"
                            >
                                Ladies Series
                            </Link>
                            <Link
                                style={{
                                    textDecoration: "none",
                                    padding: "20px",
                                }}
                                onClick={() => {
                                    setShowSeries(false);
                                    setShowMenu(false);
                                }}
                                to="/products/all"
                            >
                                All Series
                            </Link>
                        </Dropddown>
                    </Container>
                )}
            </Container>
        </>
    );
};

export default MobileNavbar;
